import { render, staticRenderFns } from "./OkVeridas.vue?vue&type=template&id=f2e5a330&scoped=true"
import script from "./OkVeridas.vue?vue&type=script&lang=js"
export * from "./OkVeridas.vue?vue&type=script&lang=js"
import style0 from "./OkVeridas.vue?vue&type=style&index=0&id=f2e5a330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e5a330",
  null
  
)

export default component.exports